import Colors from "styles/colors";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR } from "styles/color-consts";

const NextCarouselArrow = ({ isDisabled, color = Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR] }) => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Next item</title>
      <path
        d="M22.0607 10.9393C22.6464 11.5251 22.6464 12.4749 22.0607 13.0607L12.5147 22.6066C11.9289 23.1924 10.9792 23.1924 10.3934 22.6066C9.80761 22.0208 9.80761 21.0711 10.3934 20.4853L18.8787 12L10.3934 3.51472C9.80761 2.92893 9.80761 1.97918 10.3934 1.3934C10.9792 0.807609 11.9289 0.807609 12.5147 1.3934L22.0607 10.9393ZM-2.93491e-07 10.5L21 10.5L21 13.5L2.93491e-07 13.5L-2.93491e-07 10.5Z"
        fill={isDisabled ? Colors.gainsboro : color}
      />
    </svg>
  );
};

export default NextCarouselArrow;
